<mat-horizontal-stepper>
    @for (lotMappedItem of lotMappedItems; track lotMappedItem.id) {
        <mat-step>
            <ng-template matStepLabel>
                <span class="lot-document-step-label">
                    <span>{{ getStepLabel(lotMappedItem) }}</span>
                    <mat-icon
                        class="lot-document-info-icon"
                        (click)="$event.stopPropagation()"
                        [matTooltip]="getSelectedDocumentsTooltip(lotMappedItem.id)"
                        matTooltipPosition="above"
                        matTooltipClass="lot-selection-tooltip"
                    >
                        info
                    </mat-icon>
                </span>
            </ng-template>

            <cb-document
                *cbWaitFor="lotMappedItem"
                [entity]="lotMappedItem"
                [permissions]="lotPermissions.getDocumentPermissions()"
                [includeLinked]="true"
                [hideUploadButton]="true"
                [edit]="false"
                [hideEmpty]="true"
                [hideDeletedToggle]="true"
                [systemArea]="systemArea"
                [documentsEntityUri]="migrateLotsWizardDocumentUri"
                [enableCheckbox]="true"
                (documentSelectionUpdated)="handleLotDocumentSelectionUpdated(lotMappedItem, $event)"
                [showPdfButton]="true"
            ></cb-document>
        </mat-step>
    }
</mat-horizontal-stepper>
